(function ($) {
  if (!$("body").hasClass("theme-omdia")) return;

  var $infMenu,
    $body,
    $header,
    $main,
    $infMenuBtn,
    isMobile,
    $mainNav,
    $topTierItems,
    $topTierItem,
    $subMenus,
    $subMenu,
    $accountDropdownBtn,
    $accountDropdown,
    $overlay,
    $mobSubBack,
    $mobSubBackBtn;

  var toggleIconDelay = 200,
    mobileMenuOpenDuration = 400;

  // --- Utility ---
  var resetTimeout = function ($el, timerId) {
    if ($el.data(timerId)) {
      clearTimeout($el.data(timerId));
      $el.data(timerId, null);
    }
  };

  var openAnimation = function ($el, delay, onOpenCallback) {
    $el.addClass("opening").removeClass("closing");
    resetTimeout($el, "openingTimer");
    resetTimeout($el, "closingTimer");
    $el.data(
      "openingTimer",
      setTimeout(function () {
        $el.removeClass("opening").addClass("open");
        if (onOpenCallback) onOpenCallback();
      }, delay || 0)
    );
  };

  var closeAnimation = function ($el, delay, onCloseCallback) {
    $el.removeClass("open opening").addClass("closing");
    resetTimeout($el, "openingTimer");
    resetTimeout($el, "closingTimer");
    $el.data(
      "closingTimer",
      setTimeout(function () {
        $el.removeClass("closing");
        if (onCloseCallback) onCloseCallback();
      }, delay || 0)
    );
  };

  var toggleAnimation = function ($el, delay, onOpenCallback, onCloseCallback) {
    if ($el.hasClass("open") || $el.hasClass("opening")) {
      closeAnimation($el, delay, onCloseCallback);
    } else {
      openAnimation($el, delay, onOpenCallback);
    }
  };

  var createMobileBack = function () {
    var $subMenuContainer = $(".mob-sub-container");
    $mobSubBackBtn = $('<a href="#">Back</a>');
    $mobSubBack = $('<div class="mob-sub-back" />');

    $mobSubBack.append($mobSubBackBtn);
    $subMenuContainer.append($mobSubBack);

    $subMenuContainer.find(".mob-sub-back").on("click", function (e) {
      e.preventDefault();
      $(".mob-sub-container").removeClass(
        "mob-sub-open main-nav-sub account-access-sub"
      );
      closeAnimation($(".mob-sub-container.open"), mobileMenuOpenDuration);
      closeAnimation($mobSubBack, mobileMenuOpenDuration);
    });
  };

  // --- Init elements ---
  $body = $("body");
  $header = $("header");
  $infMenu = $(".inf-main-menu");
  $mainNav = $infMenu.find(".main-nav");
  $topTierItems = $mainNav.children("li").children("a");
  $subMenus = $topTierItems.siblings("div");
  $accountDropdownBtn = $(".account-dropdown-btn");
  $accountDropdown = $accountDropdownBtn.siblings(".account-dropdown");
  isMobile = $(window).width() <= 1201;
  $main = $("main");

  // --- Mobile menu ---
  if (isMobile) {
    $infMenuBtn = $(".inf-menu-toggler");

    // Add trigger class to items with submenus
    $topTierItems.each(function () {
      $topTierItem = $(this);
      $subMenu = $topTierItem.siblings("div");
      if ($subMenu.length > 0) $topTierItem.addClass("mob-sub-trigger");
      $subMenu.addClass("mob-sub-container");
    });

    // Mobile account dropdown
    if (!$(".entitled-user").length) {
      $accountDropdownBtn.addClass("mob-sub-trigger");
      $accountDropdown.addClass("mob-sub-container");
      $accountDropdownBtn.on("click", function (e) {
        e.preventDefault();
        $infMenu.addClass("mob-sub-open account-access-sub");
        openAnimation($accountDropdown, mobileMenuOpenDuration);
        $mobSubBack
          .addClass("account-access-sub")
          .removeClass("main-nav-sub");
        openAnimation($mobSubBack, mobileMenuOpenDuration);
      });
    } else {
      $accountDropdownBtn.on("click", function (e) {
        $accountDropdown.toggleClass("open");
        $accountDropdownBtn.toggleClass("hover");
        e.preventDefault();
      });

      // Close dropdown when clicking outside (mobile only)
      $(document).on("click", function (e) {
        if (
          $accountDropdown.hasClass("open") &&
          !$accountDropdownBtn[0].contains(e.target) &&
          !$accountDropdown[0].contains(e.target)
        ) {
          $accountDropdown.removeClass("open");
          $accountDropdownBtn.removeClass("hover");
        }
      });
    }

    createMobileBack();

    // Mobile submenu toggle
    $topTierItems.on("click", function (e) {
      $topTierItem = $(this);
      $subMenu = $topTierItem.siblings("div");
      if ($subMenu.length > 0) {
        e.preventDefault();
        $infMenu.addClass("mob-sub-open main-nav-sub");
        openAnimation($subMenu, mobileMenuOpenDuration);
        $mobSubBack.addClass("main-nav-sub").removeClass("account-access-sub");
        openAnimation($mobSubBack, mobileMenuOpenDuration);
      }
    });

    // Menu toggle button
    $infMenuBtn.children("button").on("click", function () {
      toggleAnimation($infMenuBtn, toggleIconDelay);
      toggleAnimation(
        $infMenu,
        toggleIconDelay,
        function () {
          $body.addClass("mob-nav-open");
        },
        function () {
          $body.removeClass("mob-nav-open");
          setTimeout(function () {
            $infMenu.removeClass(
              "mob-sub-open main-nav-sub account-access-sub"
            );
            $mobSubBack.removeClass("open account-access-sub main-nav-sub");
            $accountDropdown.removeClass("open");
            $infMenu.find(".mob-sub-container").removeClass("open");
          }, toggleIconDelay);
        }
      );
    });

    // --- Desktop menu ---
  } else {
    $main = $("main");
    $overlay = $('<div class="inf-menu-body-overlay" />');
    $body.append($overlay);

    $mainNav.data("open-submenu", $());

    $subMenus.each(function (index) {
      $(this).attr("id", index + 1);
    });

    $topTierItems.on("click", function (e) {
      $(this).parent().toggleClass("hover").siblings().removeClass("hover");
      e.preventDefault();
    });

    $mainNav.on("focusout", function (e) {
      if (
        !this.contains(e.relatedTarget) ||
        $(e.relatedTarget).parent().parent().hasClass("main-nav")
      ) {
        $(this).children("li").removeClass("hover");
      }
    });

    $topTierItems.each(function () {
      var $topTierLi = $(this).parent();
      $topTierLi.on("mouseleave", function () {
        $(this).removeClass("hover");
      });
      $topTierLi.on("mouseenter", function () {
        $(this).addClass("hover").siblings().removeClass("hover");
      });
    });

    function openDropdown() {
      $accountDropdown.addClass("open");
      $accountDropdownBtn.addClass("hover");
    }

    function closeDropdown() {
      $accountDropdown.removeClass("open");
      $accountDropdownBtn.removeClass("hover");
    }

    // CLICK toggle
    $accountDropdownBtn.on("click", function (e) {
      e.preventDefault();
      $accountDropdown.hasClass("open") ? closeDropdown() : openDropdown();
    });

    // HOVER support
    $accountDropdownBtn.on("mouseenter", openDropdown);
    $accountDropdown.on("mouseenter", openDropdown);

    $accountDropdownBtn.on("mouseleave", function () {
      setTimeout(function () {
        if (!$accountDropdown.is(":hover")) {
          closeDropdown();
        }
      }, 100);
    });

    $accountDropdown.on("mouseleave", closeDropdown);

    var $usernameBtn = $(".username-btn");
    var $usernameDropdown = $usernameBtn.siblings(".username-dropdown");

    if (isMobile) {
      $usernameBtn.addClass("mob-sub-trigger");
      $usernameDropdown.addClass("mob-sub-container");

      $usernameBtn.on("click", function (e) {
        e.preventDefault();

        $infMenu.addClass("mob-sub-open account-access-sub");

        openAnimation($usernameDropdown, mobileMenuOpenDuration);

        $mobSubBack.addClass("account-access-sub").removeClass("main-nav-sub");

        openAnimation($mobSubBack, mobileMenuOpenDuration);
      });
    } else {
      if (!$(".entitled-user").length) {
        // $usernameBtn.on("click", function (e) {
        //   e.preventDefault();
        //   $usernameDropdown.toggleClass("open");
        //   $usernameBtn.toggleClass("hover");
        // });

        // $usernameBtn.on("click", function (e) {
        //   e.preventDefault();
        //   $usernameDropdown.removeClass("open");
        //   $usernameBtn.removeClass("hover");
        // });

        $usernameBtn.on("mouseenter", function () {
          $usernameDropdown.addClass("open");
          $usernameBtn.addClass("hover");
        });

        $usernameDropdown.on("click", "a", function () {
          $usernameDropdown.removeClass("open");
          $usernameBtn.removeClass("hover");
        });

        $usernameBtn.closest("li").on("mouseleave", function () {
          $usernameDropdown.removeClass("open");
          $usernameBtn.removeClass("hover");
        });

        $(document).on("click", function (e) {
          if (
            !$usernameBtn[0].contains(e.target) &&
            !$usernameDropdown[0].contains(e.target)
          ) {
            $usernameDropdown.removeClass("open");
            $usernameBtn.removeClass("hover");
          }
        });
      }
    }

    if (!$(".entitled-user").length) {
      $accountDropdownBtn.on("mouseenter", function () {
        $accountDropdown.addClass("open");
        $accountDropdownBtn.addClass("hover");
      });
      $accountDropdownBtn.closest("li").on("mouseleave", function () {
        $accountDropdown.removeClass("open");
        $accountDropdownBtn.removeClass("hover");
      });
      $accountDropdown.parent().on("focusout", function (e) {
        if (!this.contains(e.relatedTarget)) {
          $accountDropdown.removeClass("open");
          $accountDropdownBtn.removeClass("hover");
        }
      });
    }
  }
})(Zepto);
